<div class="page-load-animation"></div>
<mee-loading-overlay [loading]="isLoading" [mode]="'full'"></mee-loading-overlay>
<router-outlet></router-outlet>
